<!-- ============================================================== -->
<!-- Left Sidebar - style you can find in sidebar.scss  -->
<!-- ============================================================== -->
<aside class="left-sidebar">
    <!-- Sidebar scroll-->
    <div class="scroll-sidebar">
        <!-- User profile -->
        <div class="user-profile" style="background: url(../assets/images/background/profile-bg.jpg) no-repeat;">
            <!-- User profile image -->
            <div class="profile-img"><img src="{{usuario.imagenPerfil}}" alt="user" /></div>
            <!-- User profile text-->
            <div class="profile-text">
                <a href="#" class="dropdown-toggle link u-dropdown" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="true">
                    <font color="#FFFFFF"><b>{{ usuario.nombre }} {{ usuario.apellido }}</b></font><span class="caret"></span></a>
                <div class="dropdown-menu animated flipInY">
                    <!--
                    <a href="#" class="dropdown-item"><i class="ti-user"></i> My Profile</a>
                    <a href="#" class="dropdown-item"><i class="ti-wallet"></i> My Balance</a>
                    <a href="#" class="dropdown-item"><i class="ti-email"></i> Inbox</a>
                    -->
                    <div class="dropdown-divider"></div>
                    <a href="#" class="dropdown-item"><i class="ti-settings"></i> Account Setting</a>
                    <div class="dropdown-divider"></div>
                    <a href="login.html" class="dropdown-item"><i class="fa fa-power-off"></i> Logout</a>
                </div>
            </div>
        </div>
        <!-- End User profile text-->
        <!-- Sidebar navigation-->
        <nav class="sidebar-nav">
            <ul id="sidebarnav">
                <!--
                <li>
                    <a class="has-arrow " aria-expanded="false"><i class="mdi mdi-map-marker"></i>
                        <span class="hide-menu">Inventario</span></a>
                    <ul aria-expanded="false" class="collapse">
                        <li><a routerLinkActive="active" routerLink="/dashboard/inventario">Inventario Productos</a>
                        </li>
                        <li><a routerLinkActive="active" routerLink="/dashboard/almacenes">Almacenes</a></li>
                        <li><a routerLinkActive="active" routerLink="/dashboard/traspasos">Traspasos</a></li>
                    </ul>
                </li>
                -->
                <div *ngIf="elementosMenu.length == 0">
                    {{ GENERALES.cargandoMenu }} <i class="fa fa-spinner fa-pulse fa-fw"></i>
                </div>
                <!--
                    <li class="nav-small-cap"><font color="#ffffff">
                        <a style="text-decoration:none" routerLink="/dashboard">Menu Principal</a>
                        </font>
                    </li>
                -->
                <li *ngFor="let elementoMenu of elementosMenu">
                    <a class="link" (click)="irA(elementoMenu.url)">
                        <i class="mdi {{ elementoMenu.icon }}"></i>
                        <span class="hide-menu">{{ elementoMenu.nombre }}</span>
                    </a>
                </li>
                <!--
                <ul *ngIf="boolMenuDesplegable">
                    <li *ngFor="let elementoMenu of elementosMenu">
                        <a class="link" (click)="irA(elementoMenu.url)">
                            <i class="mdi {{ elementoMenu.icon }}"></i>
                            <span class="hide-menu">{{ elementoMenu.nombre }}</span>
                        </a>
                    </li>
                </ul>
                -->
            </ul>
        </nav>
        <!-- End Sidebar navigation -->
    </div>
    <!-- End Sidebar scroll-->
    <!-- Bottom points-->
    <!--
    <div class="sidebar-footer">-->
    <!-- item-->
    <!-- <a href="" class="link" data-toggle="tooltip" title="Settings"><i class="ti-settings"></i></a>-->
    <!-- item-->
    <!-- <a href="" class="link" data-toggle="tooltip" title="Email"><i class="mdi mdi-gmail"></i></a>-->
    <!-- item-->
    <!--  <a href="" class="link" data-toggle="tooltip" title="Logout"><i class="mdi mdi-power"></i></a>-->
    <!--  </div>
    -->
    <!-- End Bottom points-->
</aside>
<!-- ============================================================== -->
<!-- End Left Sidebar - style you can find in sidebar.scss  -->
<!-- ============================================================== -->


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_shared/left-side-bar/left-side-bar.component.html